<template>
    <div class="ah-panel setup-statment-page">
        <div class="panel-header gray init-step-header">
            <h1 class="title">收支項目</h1>
            <div class="description">
                <p>
                    設定每一筆收入、支出的類型，將每筆款項分門別類，並在財務報表中呈現圖表。
                </p>
            </div>
        </div>
        <div class="panel-body">
            <el-button type="primary" style="margin-bottom: 20px" @click="onOpenBulkSetupStatementDialog">
                收支項目範本
            </el-button>
            <div style="display:inline-block; font-size: 10.5pt; margin: 0px 15px 20px 30px; color: #555; vertical-align: top;">
                首次建立請點選範本，快速勾選您想用的收支項目，也可於下方自行新增或刪除項目。<br />
                （子項目需填寫才會出現於首頁）
            </div>
            <income-statement-editor :key="statementEditorKey" />
            <center class="actions" style="margin-top: 30px">
                <el-button type="" class="primary-action" @click="handlePrev">回上一步</el-button>
                <el-button type="primary" class="primary-action" @click="handleNext">下一步</el-button>
            </center>
        </div>
        <BulkSetupStatementDialog
            :visible="isBulkSetupStatementDialogVisible"
            :key="`${statementEditorKey}-dialog`"
            @refresh="onRefreshBulkSetupStatementDialog"
            @close="onCloseBulkSetupStatementDialog"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import IncomeStatementEditor from '@/components/dashboard/Finance/TradeStatementSetting/IncomeStatementEditor.vue';
import BulkSetupStatementDialog from '@/components/ui/Statement/BulkSetupStatementDialog.vue';

export default {
    components: {
        IncomeStatementEditor,
        BulkSetupStatementDialog,
    },
    data() {
        return {
            isFirstTime: false,

            isBulkSetupStatementDialogVisible: false,
            statementEditorKey: +new Date(),
        };
    },
    created() {
        this.initIsFirstTime();
    },
    methods: {
        onOpenBulkSetupStatementDialog() {
            this.isBulkSetupStatementDialogVisible = true;
        },
        onCloseBulkSetupStatementDialog() {
            this.isBulkSetupStatementDialogVisible = false;
        },
        onRefreshBulkSetupStatementDialog() {
            setTimeout(() => {
                this.statementEditorKey = +new Date();
            }, 300);
        },
        async initIsFirstTime() {
            const resp = await this.$api({
                url: 'Tool/GetIncomeStatementSettings',
                method: 'GET',
            });

            this.isFirstTime = !_.flatMap(resp.data).length;
        },

        // 上一步
        handlePrev() {
            this.$router.push({ name: 'setup-bank' });
        },

        // 下一步
        handleNext() {
            this.$router.push({ name: 'setup-audit' });
        },
    },
};
</script>
<style lang="scss">
.ah-statement-list-wrapper {
    display: table;

    .ah-statement-list {
        display: table-cell;
        margin-right: 10px;
        vertical-align: top;

        .group-wrapper {
            position: relative;
            width: 220px;
            margin: 5px;
            border: 1px solid #ddd;
            border-radius: 6px;
            background-color: #fff;

            .group {
                .title {
                    border-bottom: 1px solid #ddd;
                    padding: 5px 5px 5px 25px;

                    .group-delete-btn {
                        position: absolute;
                        top: 0;
                        right: 5px;
                        font-size: 9pt;
                        font-weight: normal;
                        color: #ccc;

                        &:hover {
                            color: red;
                        }
                    }
                }
            }
        }
    }

    .editable-item {
        position: relative;
        font-size: 11pt;
        background-color: #f4f4f4;
        margin: 3px;
        color: #444;
        border-radius: 5px;

        &:hover {
            color: #000;
        }

        &.group {
            background-color: #fff;
        }

        .handle {
            position: absolute;
            top: 0;
            left: 0;
            width: 25px;
            height: 34px;
            cursor: move;

            &:before {
                position: absolute;
                top: 15px;
                left: 8px;
                content: "";
                width: 12px;
                height: 1px;
                background-color: #ccc;
            }

            &:after {
                position: absolute;
                top: 20px;
                left: 8px;
                content: "";
                width: 12px;
                height: 1px;
                background-color: #ccc;
            }
        }

        .name {
            position: relative;
            padding: 5px 5px 5px 5px;
            margin-left: 30px;

            .text {
                display: block;
                height: 26px;
                min-width: 100px;
            }

            .input {
                display: none;
                background-color: #fff;
            }
        }

        &.edit-mode {
            .handle {
                display: none;
            }

            .name {
                margin-left: 0;

                .text {
                    display: none;
                }

                .input {
                    display: block;
                }
            }

            .item-delete-btn {
                display: none;
            }
        }

        .item-delete-btn {
            position: absolute;
            top: 0;
            right: 5px;
            font-size: 9pt;
            font-weight: normal;
            color: #ccc;

            &:hover {
                color: red;
            }
        }
    }
}
</style>
